/**
 * Event Create Page
 *
 * Renders the unified EIB event-creation wizard (create-only). The wizard
 * collects the basics, creates the event as `scheduled`, then flows directly
 * into the reused Event-in-a-Box setup steps — no navigate-away / modal re-open.
 *
 * EDIT still uses the shared EventForm via EventEdit.tsx — unchanged.
 */

import React from "react";
import { useSearchParams } from "react-router-dom";
import EventCreateWizard from "../components/events/EventCreateWizard";

const EventCreate: React.FC = () => {
  // `?resume=<eventId>` re-opens the wizard in "Configure Event" mode for an
  // already-created (setup-incomplete) event, entering at the Team step.
  const [params] = useSearchParams();
  const resumeEventId = params.get("resume") || undefined;
  return <EventCreateWizard resumeEventId={resumeEventId} />;
};

export default EventCreate;
